import React, { useState, useRef, useEffect } from 'react';

const AIChatWidget = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { role: 'assistant', content: 'Zdravo! Ja sam NAŠA AI Asistent. Postavi mi pitanje o NAŠA platformi, Tonini Bitlab ekosistemu ili MY.N.E.R. tehnologiji i rado ću pomoći.' }
  ]);
  const [input, setInput] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [hovered, setHovered] = useState(false);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 100);
    }
  }, [messages, isOpen]);

  const handleSend = async () => {
    if (!input.trim() || isLoading) return;
    const userMsg = { role: 'user', content: input };
    const newMessages = [...messages, userMsg];
    setMessages(newMessages);
    setInput('');
    setIsLoading(true);
    try {
      const response = await fetch('/api/chat', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ messages: newMessages })
      });
      const data = await response.json();
      if (response.ok) {
        setMessages([...newMessages, { role: 'assistant', content: data.reply }]);
      } else {
        setMessages([...newMessages, { role: 'assistant', content: 'Došlo je do greške. Pokušaj ponovo.' }]);
      }
    } catch {
      setMessages([...newMessages, { role: 'assistant', content: 'Greška pri slanju poruke.' }]);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ fontFamily: '"JetBrains Mono", monospace' }}>

      {/* Full screen modal */}
      {isOpen && (
        <div style={{
          position: 'fixed',
          bottom: '80px',
          right: '20px',
          width: '370px',
          height: '520px',
          zIndex: 99999,
          backgroundColor: '#000',
          border: '1px solid #22ff77',
          borderRadius: '10px',
          display: 'flex',
          flexDirection: 'column',
          boxShadow: '0 0 20px rgba(34,255,119,0.2)',
          overflow: 'hidden',
        }}>
          {/* Header */}
          <div style={{
            backgroundColor: '#111',
            borderBottom: '1px solid #22ff77',
            padding: '16px 20px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexShrink: 0,
          }}>
            <span style={{ color: '#22ff77', fontWeight: 'bold', fontSize: '15px', letterSpacing: '0.1em' }}>
              NAŠA AI Asistent
            </span>
            <button onClick={() => { setIsOpen(false); setHovered(false); }} style={{
              background: 'none', border: 'none', color: '#ff7a18',
              cursor: 'pointer', fontSize: '20px', fontWeight: 'bold', lineHeight: 1,
            }}>✖</button>
          </div>

          {/* Poruke */}
          <div style={{
            flex: 1,
            overflowY: 'auto',
            padding: '16px',
            display: 'flex',
            flexDirection: 'column',
            gap: '12px',
          }}>
            {messages.map((m, idx) => (
              <div key={idx} style={{
                alignSelf: m.role === 'user' ? 'flex-end' : 'flex-start',
                backgroundColor: m.role === 'user' ? '#1a1a1a' : '#0a0a0a',
                border: `1px solid ${m.role === 'user' ? '#ff7a18' : '#22ff77'}`,
                color: '#fff',
                padding: '12px 16px',
                borderRadius: '8px',
                maxWidth: '85%',
                fontSize: '14px',
                lineHeight: '1.6',
                whiteSpace: 'pre-wrap',
              }}>
                {m.content}
              </div>
            ))}
            {isLoading && (
              <div style={{ color: '#22ff77', fontSize: '12px', fontStyle: 'italic' }}>
                AI kuca odgovor...
              </div>
            )}
            <div ref={messagesEndRef} />
          </div>

          {/* Input */}
          <div style={{
            borderTop: '1px solid #22ff77',
            padding: '12px 16px',
            display: 'flex',
            gap: '10px',
            backgroundColor: '#111',
            flexShrink: 0,
          }}>
            <input
              ref={inputRef}
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === 'Enter' && handleSend()}
              onFocus={() => setTimeout(() => messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' }), 300)}
              placeholder="Pitaj me nešto..."
              style={{
                flex: 1,
                backgroundColor: '#000',
                color: '#22ff77',
                border: '1px solid #22ff77',
                borderRadius: '5px',
                padding: '12px',
                outline: 'none',
                fontFamily: '"JetBrains Mono", monospace',
                fontSize: '14px',
              }}
            />
            <button onClick={handleSend} disabled={isLoading} style={{
              backgroundColor: '#ff7a18',
              color: '#000',
              border: 'none',
              borderRadius: '5px',
              padding: '0 18px',
              cursor: 'pointer',
              fontWeight: 'bold',
              fontSize: '18px',
            }}>
              {'>'}
            </button>
          </div>
        </div>
      )}

      {/* Floating dugme */}
      {!isOpen && (
        <div style={{ position: 'fixed', bottom: window.innerWidth < 768 ? '90px' : '155px', right: '22px', zIndex: 99999, display: 'flex', alignItems: 'center' }}>
          {hovered && window.innerWidth >= 768 && (
            <div style={{
              position: 'absolute', right: '66px', top: '50%', transform: 'translateY(-50%)',
              backgroundColor: '#000', border: '1px solid #22ff77',
              padding: '6px 12px', borderRadius: '4px', whiteSpace: 'nowrap',
              color: '#22ff77', fontSize: '11px', letterSpacing: '0.2em', textTransform: 'uppercase',
              fontFamily: '"JetBrains Mono", monospace', fontWeight: 'bold',
            }}>
              Adria Asistent
            </div>
          )}
          <button
            onClick={() => { if (window.innerWidth < 768) { window.location.href = "/asistent"; } else { setIsOpen(true); } }}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            style={{
              backgroundColor: '#22ff77', color: '#000', border: 'none',
              borderRadius: '50%', width: '56px', height: '56px',
              cursor: 'pointer', fontSize: '24px', fontWeight: 'bold',
              boxShadow: '0 0 15px rgba(34,255,119,0.5)',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
            }}>
            💬
          </button>
        </div>
      )}
    </div>
  );
};

export default AIChatWidget;
